<template>
    <img class="defaqto-logo" src="@img/defaqto-2026.png" alt="Defaqto" />
</template>

<style scoped>
.defaqto-logo {
    max-width: 250px;
}
</style>
